var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".factory-container[data-v-8aea8740] {\n  width: 100%;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.factory-container.active[data-v-8aea8740] {\n  background-image: url(" + escape(require(".././assets/svg/coolbg.png")) + ");\n  background-repeat: no-repeat;\n  background-size: cover;\n}", ""]);

// exports
